class ResaleInvestments {
    numberOfBricks;
    investedAmount;
    rentsAmounts;
    property;
    constructor(data) {
        this.numberOfBricks = data.numberOfBricks;
        this.investedAmount = data.investedAmount;
        this.rentsAmounts = data.rentsAmounts;
        this.property = data.property;
    }
}
export default ResaleInvestments;
